<template>
  <div ref="r_preloader"></div>
</template>

<script>

  import * as api from '../api'

  export default {
    name      : 'preloader',

    props:{
      url: {type: String, default:'/action/preloader/work4'},
    },

    created(){
      this.$nextTick(function(){
        api.get(this.url).then(response => {
          $(this.$refs.r_preloader).html( response.data );
        }).catch(e => {
          console.log(e);
        })
      })
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/Preloader.vue